import { QuestionBase } from './question-base.model';

export class ButtonQuestion extends QuestionBase<string> {
    controlType = 'button';
    type: string;
    name: string;
    class: string;
    id: string;
    visible: string;
    show_label: any;
    buttonIcon: any;
    emitOnSave: any;
    permission_check: any;
    disabled: boolean = false;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.name = options['name'] || '',
        this.class = options['class'] || '',
        this.id = options['id'] || '',
        this.buttonIcon = options['buttonIcon'],
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
        this.show_label = options['show_label'];
        this.disabled = (options['disabled']==undefined)?false: options['disabled'];
        this.emitOnSave = options['emitOnSave'] != undefined ? options['emitOnSave'] : true;
        this.permission_check = options['permission_check'] ? options['permission_check'] : false;
    }
}